<template>
  <!-- 顶部导航栏 -->
  <div class="nav">
    <div class="logo" @click="reload">
      <img class="logo_img" src="@/assets/img/logo.png" alt="翼任科技" />
      <div class="logo_hover"></div>
    </div>
    <router-link
      :class="activeIndex == item.id ? 'active' : 'hvr-underline-from-center'"
      v-for="item in NavList"
      :key="item.id"
      :to="item.path"
      @click.native="select(item.id)"
      >{{ item.name }}</router-link
    >
  </div>
</template>
<script>
export default {
  name: "NavBar",
  components: {},
  props: {
    idx: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    idx(newVal) {
      // console.log(newVal,'asdf')
      this.activeIndex = newVal;
    },
  },
  data() {
    return {
      NavList: [
        {
          name: "首页",
          path: "/",
          id: 0,
        },
        {
          name: "工业物联网",
          path: "/inDusTry",
          id: 1,
        },
        {
          name: "智慧城市",
          path: "/city",
          id: 2,
        },
        {
          name: "智慧停车",
          path: "/park",
          id: 3,
        },
        {
          name: "公司介绍",
          path: "/info",
          id: 4,
        },
        {
          name: "联系我们",
          path: "/call",
          id: 5,
        },
      ],
      activeIndex: window.localStorage.getItem("activeIndex")
        ? window.localStorage.getItem("activeIndex")
        : 0,
    };
  },
  methods: {
    select(idx) {
      this.activeIndex = idx;
      this.$emit("changIdx", idx);
      window.scrollTo(0, 0);
      window.localStorage.setItem("activeIndex", idx);
    },
    reload() {
      if (this.$route.path == "/") {
        location.reload();
        window.scrollTo(0, 0);
        return;
      }
      this.$router.push("/");
      this.activeIndex = 0;
      window.scrollTo(0, 0);
    },
  },
};
</script>
<style lang="less" scoped>
.nav {
  width: 100%;
  height: 103px;
  background-color: black;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  position: sticky;
  top: 0;
  padding-right: 100px;
  z-index: 99;
  span,
  a {
    color: #c3c3c3;
    display: inline-block;
    line-height: 103px;
    height: 100%;
  }
  a:hover {
    color: white;
    cursor: pointer;
  }
  .logo_img {
    width: 64px;
    height: 59px;
  }
  .logo {
    position: relative;
  }
  .logo_hover {
    position: absolute;
    display: none;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }
  .logo:hover .logo_hover {
    display: block;
    cursor: pointer;
  }

  .active {
    border-bottom: 3px solid #00a1e9;
    color: white;
    cursor: pointer;
  }
}
</style>
